import axios from "@/utils/axiosRequest"
// 获取新闻
export const getNews= (news)=>{
    return axios.request({
        url:"/note/selvypublics",
        method:"POST",
        data:news
    })
}
// 获取新闻详情
export const getNewsDetail = (news)=>{
    return axios.request({
        url:"/note/onepublic",
        method:"POST",
        data:news
    })
}
// 新闻模糊查询
export const getKeywordNews = (news)=>{
    return axios.request({
        url:"/note/selvypublics",
        method:"POST",
        data:news
    })
}
// 获取信息公开
export const getInfo= (news)=>{
    return axios.request({
        url:"/tianwei/selmag",
        method:"POST",
        data:news
    })
}
// 获取信息公开详情
export const getInfoDetail = (news)=>{
    return axios.request({
        url:"/tianwei/selmag",
        method:"POST",
        data:news
    })
}